"use client";

import ErrorDisplay from "@/components/ErrorDisplay";

export default function MarketOverviewError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <ErrorDisplay error={error} reset={reset} section="Market Overview" />;
}
